package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.Playstation5SimpleIcons: ImageVector
    get() {
        if (_playstation5SimpleIcons != null) {
            return _playstation5SimpleIcons!!
        }
        _playstation5SimpleIcons = Builder(name = "Playstation5SimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(10.45f, 14.57f)
                arcToRelative(1.38f, 1.38f, 0.0f, false, false, 1.38f, -1.38f)
                verticalLineToRelative(-2.38f)
                arcToRelative(0.83f, 0.83f, 0.0f, false, true, 0.83f, -0.83f)
                horizontalLineToRelative(2.68f)
                arcToRelative(0.04f, 0.04f, 0.0f, false, false, 0.04f, -0.04f)
                lineTo(15.39f, 9.46f)
                arcToRelative(0.04f, 0.04f, 0.0f, false, false, -0.04f, -0.04f)
                lineTo(12.12f, 9.43f)
                arcToRelative(1.38f, 1.38f, 0.0f, false, false, -1.38f, 1.38f)
                verticalLineToRelative(2.38f)
                arcToRelative(0.83f, 0.83f, 0.0f, false, true, -0.83f, 0.83f)
                lineTo(7.25f, 14.02f)
                arcToRelative(0.04f, 0.04f, 0.0f, false, false, -0.04f, 0.04f)
                verticalLineToRelative(0.48f)
                arcToRelative(0.04f, 0.04f, 0.0f, false, false, 0.04f, 0.04f)
                close()
                moveTo(16.50f, 11.36f)
                lineTo(16.50f, 9.46f)
                arcToRelative(0.04f, 0.04f, 0.0f, false, true, 0.04f, -0.04f)
                horizontalLineToRelative(7.31f)
                arcToRelative(0.04f, 0.04f, 0.0f, false, true, 0.04f, 0.04f)
                verticalLineToRelative(0.48f)
                arcToRelative(0.04f, 0.04f, 0.0f, false, true, -0.04f, 0.04f)
                horizontalLineToRelative(-6.21f)
                arcToRelative(0.04f, 0.04f, 0.0f, false, false, -0.04f, 0.04f)
                verticalLineToRelative(1.24f)
                arcToRelative(0.40f, 0.40f, 0.0f, false, false, 0.40f, 0.40f)
                horizontalLineToRelative(4.62f)
                arcToRelative(1.47f, 1.47f, 0.0f, false, true, 0.0f, 2.93f)
                horizontalLineToRelative(-6.08f)
                arcToRelative(0.04f, 0.04f, 0.0f, false, true, -0.04f, -0.04f)
                verticalLineToRelative(-0.47f)
                arcToRelative(0.04f, 0.04f, 0.0f, false, true, 0.04f, -0.04f)
                horizontalLineToRelative(5.53f)
                arcToRelative(0.92f, 0.92f, 0.0f, true, false, -0.01f, -1.83f)
                horizontalLineToRelative(-4.73f)
                arcToRelative(0.83f, 0.83f, 0.0f, false, true, -0.83f, -0.83f)
                moveToRelative(-10.85f, 0.29f)
                arcToRelative(0.84f, 0.84f, 0.0f, false, false, 0.0f, -1.67f)
                lineTo(0.04f, 9.98f)
                arcToRelative(0.04f, 0.04f, 0.0f, false, true, -0.04f, -0.04f)
                lineTo(0.0f, 9.46f)
                arcToRelative(0.04f, 0.04f, 0.0f, false, true, 0.04f, -0.04f)
                horizontalLineToRelative(6.15f)
                arcToRelative(1.38f, 1.38f, 0.0f, false, true, 0.0f, 2.77f)
                lineTo(1.93f, 12.19f)
                arcToRelative(0.83f, 0.83f, 0.0f, false, false, -0.83f, 0.83f)
                verticalLineToRelative(1.51f)
                arcToRelative(0.04f, 0.04f, 0.0f, false, true, -0.04f, 0.04f)
                lineTo(0.04f, 14.58f)
                arcToRelative(0.04f, 0.04f, 0.0f, false, true, -0.04f, -0.04f)
                verticalLineToRelative(-1.51f)
                arcToRelative(1.38f, 1.38f, 0.0f, false, true, 1.38f, -1.38f)
                close()
            }
        }
        .build()
        return _playstation5SimpleIcons!!
    }

private var _playstation5SimpleIcons: ImageVector? = null
